import styles from "./EditionsCarousel.module.css"
import typo from "../../typography.module.css"
import { forwardRef, useEffect, useState } from "react"
import { Each } from "../../common/Each"
import EditionLessonsCard from "../cards/EditionLessonsCard"
import api from "../../api"
import Loader from "../Loader"
import { UTCtoLocal } from "../../utils"
import { Splide, SplideSlide } from "@splidejs/react-splide"
import '@splidejs/react-splide/css';
import '@splidejs/splide/css/core';

const EditionsCarousel = forwardRef(({ id, course_id, accentColor, style, onClick }, ref) => {

    const [editions, setEditions] = useState([])
    const [loading, setLoading] = useState(false)
    console.log('accentColor', accentColor)

    useEffect(() => {
        const getEditions = async () => {
            setLoading(true)
            try {
                let editions = await api.get(`/admin/courses/${course_id}/editions?public_only=true`)
                setEditions(editions ?? [])
            }
            catch (e) {
                console.error(e)
            }
            setLoading(false)
        }

        if (course_id) {
            getEditions()
        }

    }, [course_id])

    return (
        <>
            {Array.isArray(editions) &&
                <div id={id} ref={ref} className={`${styles.classesRow} ${editions.length === 0 ? styles.empty : ''}`} style={{ ...style, '--accent-color': accentColor }} onClick={onClick}>
                    {loading &&
                        <Splide
                            className="edition-carousel"
                            options={{
                                arrows: false,
                                pagination: false,
                                drag: false,
                                perPage: 1,
                                gap: '1rem',
                            }}
                        >
                            <SplideSlide>
                                <EditionLessonsCard
                                    edition={null}
                                    active={false}
                                    loading={true} />
                            </SplideSlide>
                        </Splide>
                    }
                    {editions.length === 0 && !loading &&
                        <div className={typo.headline}>Il calendario didattico è in fase di definizione, nuove edizioni arriveranno presto. Ti avviseremo non appena saranno disponibili!</div>
                    }
                    {editions.length > 0 && !loading &&
                        <Splide
                            className="edition-carousel"
                            options={{
                                perPage: 1,
                                gap: '1rem',
                                pagination: true,
                                arrows: true,
                            }}
                        >
                            <Each of={editions.sort((a, b) => {
                                const aLessons = a.modules.flatMap(module => module.lessons).sort((a, b) => {
                                    return UTCtoLocal(a.starts_at) - UTCtoLocal(b.starts_at)
                                })
                                const bLessons = b.modules.flatMap(module => module.lessons).sort((a, b) => {
                                    return UTCtoLocal(a.starts_at) - UTCtoLocal(b.starts_at)
                                })

                                return new Date(aLessons[0].starts_at) - new Date(bLessons[0].starts_at)

                            })} render={(edition) => {
                                if (edition.modules.flatMap(module => module.lessons).length > 0) {
                                    return (
                                        <SplideSlide key={edition.id}>
                                            <EditionLessonsCard
                                                edition={edition}
                                                active={false}
                                                style={{ '--accent-color': accentColor }} />
                                        </SplideSlide>
                                    )
                                }
                            }} />
                        </Splide>
                    }
                </div>

            }
            {typeof editions === 'object' && !Array.isArray(editions) &&
                <div style={{ display: 'flex', flexDirection: 'column', gap: style?.gap || '1rem' }}>
                    <Each of={Object.keys(editions)} render={(key) => (
                        <div className={`${styles.classesRow} ${editions[key].length === 0 ? styles.empty : ''}`} style={style}>
                            {loading &&
                                <Loader />
                            }
                            {!loading && editions[key].length === 0 &&
                                <div className={typo.headline}>Il calendario didattico è in fase di definizione, nuove edizioni arriveranno presto. Ti avviseremo non appena saranno disponibili!</div>
                            }
                            <div className={styles.groups}>
                                <div className={styles.groupsInner}>
                                    <Each of={editions[key].sort((a, b) => {
                                        const aLessons = a.modules.flatMap(module => module.lessons).sort((a, b) => {
                                            return UTCtoLocal(a.starts_at) - UTCtoLocal(b.starts_at)
                                        })
                                        const bLessons = b.modules.flatMap(module => module.lessons).sort((a, b) => {
                                            return UTCtoLocal(a.starts_at) - UTCtoLocal(b.starts_at)
                                        })

                                        return new Date(aLessons[0].starts_at) - new Date(bLessons[0].starts_at)

                                    })} render={(edition) => {
                                        if (edition.modules.flatMap(module => module.lessons).length > 0) {
                                            return (
                                                <div className={styles.groupCard} key={edition.id}>
                                                    <EditionLessonsCard
                                                        showRemaining={false}
                                                        edition={edition}
                                                        active={false}
                                                        style={{ cursor: 'default', '--accentColor': accentColor }}
                                                        selectable={false} />
                                                </div>
                                            )
                                        }
                                    }} />
                                </div>
                            </div>
                        </div>
                    )} />
                </div>
            }
        </>
    )

})

export default EditionsCarousel